import {motion} from 'framer-motion'
import {Link} from 'react-router-dom'
import { useLocation } from 'react-router-dom';
import {fade} from '../Variants/aboutVariants'

const NavDesktop = () => {
    const {pathname} = useLocation();

    return(
        <motion.div className='nav-links'
        variants={fade}
        initial="initial"
        animate="animate">
            <ul>
                <li>
                    <Link to="/">Home
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </li>
                <li>
                    <Link to="/about">About
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/about" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                    
                </li>
                <li >
                    <Link to="/projects">Projects
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/projects" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </li>
                <li>
                    <Link to="/drawings">Drawings
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/drawings" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </li>
                <li>
                    <Link to="/contact">Contact
                    <motion.div className="nav-line" 
                    animate={{width: pathname === "/contact" ? "100%" : 0}}
                    transition={{duration: .75}}/></Link>
                </li>
            </ul>
        </motion.div>
    )
}

export default NavDesktop;
